import { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { FormControl, Tab, Grid, Table } from "@/comn/components";
import { comnEnvs, comnUtils } from "@/comn/utils";
import { Page, Group, Layout, Button, ExcelUpload } from "@/comn/components";
import {
    useForm,
    useToast,
    useFetch,
    useModal,
    useAuth,
    useStore,
    useGrid,
    usePopup,
    useResource,
    useExcel,
    usePage,
} from "@/comn/hooks";
import {
    COMN_BASE,
    COMN_URLS,
    COMN_APIS,
    SG_APP_DTL_MSG_LIST,
} from "@/tz/go/egaz/osci/lpco/comn/services/OsciLpcoComnAppService";

export const APP_DTL_MSG = (props: any) => {
    const { pgeUid, menuId } = usePage();
    const { t } = useTranslation(); // Translation Hook !== 언어 변화 Hook ==!
    const navigate = useNavigate(); // Navigate Hook !== 화면 이동 Hook ==!
    const modal = useModal(); // Modal Window Hook !== Modal 창 Hook ==!
    const { pgeStore, setStore } = useStore({ pgeUid: pgeUid }); // Page Store Hook !== 화면 데이터 저장 Hook ==!
    const toast = useToast(); // Toast Message Hook !== Toast 메세지 표시 Hook ==!

    /*
     * Application Payment Info List Grid
     * !== 그리드 정의 ==!
     */
    const grid = {
        // Application Payment Info List !== 신청서 수수료 목록 ==!
        appDtlMsgList: useGrid({
            defaultSchema: SG_APP_DTL_MSG_LIST,
            page: pgeStore?.page,
            size: pgeStore?.size,
        }),
    };

    /*
     * Application Item Fetch
     * !== Fetch 정의 ==!
     */
    const fetch = {};

    /*
     * Application Item Event Handler
     * !== 이벤트 핸들러 정의 ==!
     */
    const handler = {};

    useEffect(() => {}, []);

    return (
        <Page>
            {/* <form> */}
            <Group>
                <Group.Body>
                    <Layout direction="col">
                        <Layout>
                            <Layout.Left>
                                <Group.Title title={"T_MSG"} titleSize={1}></Group.Title>
                            </Layout.Left>
                        </Layout>

                        <Group>
                            <Group.Body>
                                <Grid
                                    {...grid.appDtlMsgList.grid}
                                    // data={fetch.getRpckItmAppList.data?.rpckItmAppList}
                                    data={comnUtils.getGridData([
                                        {
                                            ntcDt: "11/03/2024 16:37",
                                            stts: "Received",
                                            msgCn: "Application fee paid, kindly submit original documents for verification",
                                        },
                                    ])}
                                    // render={render.grid_payInfoLst}
                                    // onCellClick={handler.click_GridCell_RpckItmAppList}
                                    // onRowClick={handler.click_GridRow_RpckItmAppList}
                                />
                            </Group.Body>
                        </Group>
                    </Layout>
                </Group.Body>
            </Group>
        </Page>
    );
};
